import {CdAddedCustomMeasure} from '../../../interfaces/care/cd-care-plan/cd-added-custom-measure';
import {CdFrequency} from '../../../interfaces/care/cd-care-plan/cd-frequency';
import {CdFrequencyFactory} from './cd-frequency-factory';
import {CdCustomMeasure} from '../../../interfaces/care/cd-nanda/cd-custom-measure';

export class CdAddedCustomMeasureFactory {
  /**
   *
   * @param cdAddedCustomMeasure
   */
  public static fromObject(cdAddedCustomMeasure: any): CdAddedCustomMeasure {
    return new class implements CdAddedCustomMeasure {
      cdCarePlanId: number = cdAddedCustomMeasure.c_care_plan_id;
      cdCustomMeasure: CdCustomMeasure = {
        id: cdAddedCustomMeasure.c_care_plan_item_able_id,
        name: cdAddedCustomMeasure.name,
        measureTypeId: null,
        isOwn: !!!cdAddedCustomMeasure.c_care_plan_item_able_id
      };
      comment: string = cdAddedCustomMeasure.comment;
      created: string = cdAddedCustomMeasure.created;
      id: number = cdAddedCustomMeasure.id;
      modified: string = cdAddedCustomMeasure.modified;
      parentId: number = cdAddedCustomMeasure.parent_id;
      isPfa: boolean = cdAddedCustomMeasure.is_pfa;
      type: string = cdAddedCustomMeasure.type;
      userId: number = cdAddedCustomMeasure.user_id;
      itemNumber: number = cdAddedCustomMeasure.item_number;
      itemNumberString: string = cdAddedCustomMeasure.item_number_string;
      alternativeText: string = cdAddedCustomMeasure.measure_alternative_text;
      cdFrequencies: CdFrequency[] =
        cdAddedCustomMeasure.c_frequencies ? CdFrequencyFactory.fromArray(cdAddedCustomMeasure.c_frequencies) : [];
    };
  }

  /**
   *
   * @param cdAddedCustomMeasures
   */
  public static fromArray(cdAddedCustomMeasures: any[]): CdAddedCustomMeasure[] {
    return cdAddedCustomMeasures.map(_cdAddedCustomMeasure => CdAddedCustomMeasureFactory.fromObject(_cdAddedCustomMeasure));
  }

}
